export default __webpack_public_path__ + "static/media/s-migration.3e86b21f.gif";